/** @format */

// api/constants.js
export const BASE_URL = `${process.env.REACT_APP_URL_LINK}`;
export const BASE_URL_TWO = "https://api.second-website.com/";
export const JSON_PLACEHOLDER = "https://jsonplaceholder.typicode.com/";
// ...additional URLs here